import { isNullOrEmpty } from "./isNullOrEmpty";
export const getGridVisibility = (props, appendStartSpace = true) => {
    const classes = [];
    if (props.hiddenSm)
        classes.push('ms-hiddenSm');
    if (props.hiddenMd)
        classes.push('ms-hiddenMd');
    if (props.hiddenMdDown)
        classes.push('ms-hiddenMdDown');
    if (props.hiddenMdUp)
        classes.push('ms-hiddenMdUp');
    if (props.hiddenLg)
        classes.push('ms-hiddenLg');
    if (props.hiddenLgDown)
        classes.push('ms-hiddenLgDown');
    if (props.hiddenLgUp)
        classes.push('ms-hiddenLgUp');
    if (props.hiddenXl)
        classes.push('ms-hiddenXl');
    if (props.hiddenXlDown)
        classes.push('ms-hiddenXlDown');
    if (props.hiddenXlUp)
        classes.push('ms-hiddenXlUp');
    if (props.hiddenXxl)
        classes.push('ms-hiddenXxl');
    if (props.hiddenXxlDown)
        classes.push('ms-hiddenXxlDown');
    if (props.hiddenXxlUp)
        classes.push('ms-hiddenXxlUp');
    if (props.hiddenXxxl)
        classes.push('ms-hiddenXxxl');
    if (!isNullOrEmpty(props.className))
        classes.push(props.className);
    return (appendStartSpace ? ' ' : '') + classes.join(' ');
};
